"use strict";

var _toConsumableArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var subproviders_1 = require("@0x/subproviders");

var bluebird_1 = __importDefault(require("bluebird"));

var phin_1 = __importDefault(require("phin"));

var lodash_1 = require("lodash");

var Context_1 = require("./Context");

var browserUtils_1 = require("./browserUtils");

var types_1 = require("./types");

var entities_1 = require("./entities");

var procedures_1 = require("./procedures");

var PolymathError_1 = require("./PolymathError");

var PolymathBase_1 = require("./PolymathBase");

var utils_1 = require("./utils");
/**
 * @hidden
 * Estimates the gas price to use in transactions
 *
 * @param speed - speed at which transactions should be mined
 * @param basePrice - base to multiply depending on the desired speed
 */


var calculateGasPrice = function calculateGasPrice(speed, basePrice) {
  var result = basePrice;

  switch (speed) {
    case types_1.TransactionSpeed.Slow:
      {
        break;
      }

    case types_1.TransactionSpeed.Medium:
      {
        result = basePrice.multipliedBy(2);
        break;
      }

    case types_1.TransactionSpeed.Fast:
      {
        result = basePrice.multipliedBy(3);
        break;
      }

    case types_1.TransactionSpeed.Fastest:
      {
        result = basePrice.multipliedBy(5);
        break;
      }

    default:
      {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.FatalError,
          message: 'Invalid transaction speed parameter'
        });
      }
  }

  return result;
};
/**
 * Main entry point of the Polymath SDK
 */


var Polymath = function Polymath() {
  var _this = this;

  _classCallCheck(this, Polymath);

  this.isUnsupported = false;
  this.isConnected = false;
  this.context = {};
  /**
   * Connects the client to an Ethereum node
   */

  this.connect = function (_ref) {
    var polymathRegistryAddress = _ref.polymathRegistryAddress,
        providerUrl = _ref.providerUrl,
        privateKey = _ref.privateKey,
        _ref$speed = _ref.speed,
        speed = _ref$speed === void 0 ? types_1.TransactionSpeed.Fast : _ref$speed;
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var provider, providerEngine, injectedProvider, slowDefaultGasPrice, contractWrappers, isTestnet, defaultGasPrice;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              providerEngine = new subproviders_1.Web3ProviderEngine();
              _context.next = 3;
              return browserUtils_1.getInjectedProvider();

            case 3:
              injectedProvider = _context.sent;

              if (!(providerUrl && privateKey)) {
                _context.next = 11;
                break;
              }

              providerEngine.addProvider(new subproviders_1.PrivateKeyWalletSubprovider(privateKey));
              providerEngine.addProvider(new subproviders_1.RedundantSubprovider([new subproviders_1.RPCSubprovider(providerUrl)]));
              providerEngine.start();
              provider = providerEngine;
              _context.next = 16;
              break;

            case 11:
              if (!injectedProvider) {
                _context.next = 15;
                break;
              }

              provider = injectedProvider;
              _context.next = 16;
              break;

            case 15:
              throw new PolymathError_1.PolymathError({
                code: types_1.ErrorCode.FatalError,
                message: "You must supply a provider URL and private key to the connect method if you're not using Polymath SDK in a browser environment"
              });

            case 16:
              slowDefaultGasPrice = new contract_wrappers_1.BigNumber(10).exponentiatedBy(9);
              contractWrappers = new PolymathBase_1.PolymathBase({
                provider: provider,
                polymathRegistryAddress: polymathRegistryAddress
              });
              _context.next = 20;
              return contractWrappers.isTestnet();

            case 20:
              isTestnet = _context.sent;
              _context.next = 23;
              return this.getGasPrice({
                provider: provider,
                isTestnet: isTestnet,
                defaultPrice: slowDefaultGasPrice,
                speed: speed
              });

            case 23:
              defaultGasPrice = _context.sent;
              contractWrappers = new PolymathBase_1.PolymathBase({
                provider: provider,
                polymathRegistryAddress: polymathRegistryAddress,
                defaultGasPrice: defaultGasPrice
              });
              this.context = new Context_1.Context({
                contractWrappers: contractWrappers
              });
              this.isConnected = true;
              return _context.abrupt("return", this);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };
  /**
   * Reserve a Security Token
   *
   * @param symbol - Security Token symbol
   * @param owner - address that will own the reservation (optional, use this if you want to reserve a token on behalf of someone else)
   */


  this.reserveSecurityToken = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var procedure, transactionQueue;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              procedure = new procedures_1.ReserveSecurityToken(args, this.context);
              _context2.next = 3;
              return procedure.prepare();

            case 3:
              transactionQueue = _context2.sent;
              return _context2.abrupt("return", transactionQueue);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };
  /**
   * Retrieve all Security Token Reservations currently owned by an issuer. This includes
   * Security Tokens that have already been launched
   *
   * @param owner - issuer's address (defaults to current address)
   */


  this.getSecurityTokenReservations = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var _this2 = this;

      var _this$context, currentWallet, contractWrappers, owner, symbols, reservations;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$context = this.context, currentWallet = _this$context.currentWallet, contractWrappers = _this$context.contractWrappers;

              if (!args) {
                _context3.next = 5;
                break;
              }

              owner = args.owner;
              _context3.next = 8;
              break;

            case 5:
              _context3.next = 7;
              return currentWallet.address();

            case 7:
              owner = _context3.sent;

            case 8:
              _context3.next = 10;
              return contractWrappers.securityTokenRegistry.getTickersByOwner({
                owner: owner
              });

            case 10:
              symbols = _context3.sent;
              _context3.next = 13;
              return bluebird_1.default.map(symbols, function (symbol) {
                return bluebird_1.default.resolve(_this2.getSecurityTokenReservation({
                  symbol: symbol
                })).catch(PolymathError_1.PolymathError, function (err) {
                  if (err.code === types_1.ErrorCode.FetcherValidationError) {
                    return undefined;
                  }

                  throw err;
                });
              });

            case 13:
              reservations = _context3.sent;
              return _context3.abrupt("return", lodash_1.compact(reservations));

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };
  /**
   * Retrieve a Security Token Reservation by symbol or UUID
   *
   * @param symbol - Security Token symbol
   */


  this.getSecurityTokenReservation = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var uid;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // fetch by UUID
              if (typeof args === 'string') {
                uid = args;
              } else {
                uid = entities_1.SecurityToken.generateId(args);
              }

              return _context4.abrupt("return", this.context.factories.securityTokenReservationFactory.fetch(uid));

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));
  };
  /**
   * Retrieve all launched Security Tokens related to a wallet.
   * This includes tokens owned by the wallet and tokens for which the wallet holds some role
   *
   * **Ignores** all tokens with version 2.0 or lower
   *
   * NOTE: This method is extremely slow if the wallet in question owns more than 20 tokens.
   * If that is your case, use [[getSecurityTokenSymbols]]
   *
   * @param walletAddress - defaults to current address
   */


  this.getSecurityTokens = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var _this3 = this;

      var _this$context2, currentWallet, contractWrappers, walletAddress, _ref2, _ref3, ownedAddresses, delegatedAddresses, addressChunks, result;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$context2 = this.context, currentWallet = _this$context2.currentWallet, contractWrappers = _this$context2.contractWrappers;

              if (!args) {
                _context5.next = 5;
                break;
              }

              walletAddress = args.walletAddress;
              _context5.next = 8;
              break;

            case 5:
              _context5.next = 7;
              return currentWallet.address();

            case 7:
              walletAddress = _context5.sent;

            case 8:
              _context5.next = 10;
              return Promise.all([contractWrappers.securityTokenRegistry.getTokensByOwner({
                owner: walletAddress
              }), contractWrappers.securityTokenRegistry.getTokensByDelegate(walletAddress)]);

            case 10:
              _ref2 = _context5.sent;
              _ref3 = _slicedToArray(_ref2, 2);
              ownedAddresses = _ref3[0];
              delegatedAddresses = _ref3[1];
              addressChunks = lodash_1.chunk(lodash_1.union(ownedAddresses, delegatedAddresses), 10);
              _context5.next = 17;
              return bluebird_1.default.mapSeries(addressChunks, function (addresses) {
                return bluebird_1.default.map(addresses, function (address) {
                  return bluebird_1.default.resolve(_this3.getSecurityToken({
                    address: address
                  })).catch(PolymathError_1.PolymathError, function (err) {
                    if (err.code === types_1.ErrorCode.IncorrectVersion) {
                      return undefined;
                    }

                    throw err;
                  });
                });
              });

            case 17:
              result = _context5.sent;
              return _context5.abrupt("return", lodash_1.compact(lodash_1.union.apply(lodash_1, _toConsumableArray(result))));

            case 19:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));
  };
  /**
   * Retrieve the symbols of all launched Security Tokens related to a wallet.
   * This includes tokens owned by the wallet and tokens for which the wallet holds some role
   *
   * **Includes** token symbols for tokens with version 2.0 or lower
   *
   * @param walletAddress - defaults to current address
   */


  this.getSecurityTokenSymbols = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7() {
      var _this4 = this;

      var _this$context3, currentWallet, contractWrappers, walletAddress, _ref4, _ref5, ownedTokens, delegatedTokens, allTokens, allTickers;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this$context3 = this.context, currentWallet = _this$context3.currentWallet, contractWrappers = _this$context3.contractWrappers;

              if (!args) {
                _context7.next = 5;
                break;
              }

              walletAddress = args.walletAddress;
              _context7.next = 8;
              break;

            case 5:
              _context7.next = 7;
              return currentWallet.address();

            case 7:
              walletAddress = _context7.sent;

            case 8:
              _context7.next = 10;
              return Promise.all([contractWrappers.securityTokenRegistry.getTokensByOwner({
                owner: walletAddress
              }), contractWrappers.securityTokenRegistry.getTokensByDelegate(walletAddress)]);

            case 10:
              _ref4 = _context7.sent;
              _ref5 = _slicedToArray(_ref4, 2);
              ownedTokens = _ref5[0];
              delegatedTokens = _ref5[1];
              allTokens = lodash_1.union(ownedTokens, delegatedTokens);
              _context7.next = 17;
              return bluebird_1.default.map(allTokens, function (address) {
                return __awaiter(_this4, void 0, void 0,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee6() {
                  var details;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return contractWrappers.securityTokenRegistry.getSecurityTokenData({
                            securityTokenAddress: address
                          });

                        case 2:
                          details = _context6.sent;
                          return _context6.abrupt("return", details.ticker);

                        case 4:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));
              });

            case 17:
              allTickers = _context7.sent;
              return _context7.abrupt("return", allTickers);

            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));
  };
  /**
   * Retrieve a security token by symbol, address or UUID
   *
   * @throws if the Security Token is v2.0 or lower
   */


  this.getSecurityToken = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8() {
      var uid, isAddressArgs, _this$context4, tokenFactory, factories, securityToken, _entities_1$SecurityT, symbol, address, _symbol, versionArray, versionError, version;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              // eslint-disable-next-line require-jsdoc
              isAddressArgs = function isAddressArgs(a) {
                return typeof a.address === 'string';
              };

              _this$context4 = this.context, tokenFactory = _this$context4.contractWrappers.tokenFactory, factories = _this$context4.factories;

              if (!(typeof args === 'string')) {
                _context8.next = 10;
                break;
              }

              _entities_1$SecurityT = entities_1.SecurityToken.unserialize(args), symbol = _entities_1$SecurityT.symbol;
              _context8.next = 6;
              return tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

            case 6:
              securityToken = _context8.sent;
              uid = args;
              _context8.next = 31;
              break;

            case 10:
              if (!isAddressArgs(args)) {
                _context8.next = 27;
                break;
              }

              address = args.address;
              _context8.prev = 12;
              _context8.next = 15;
              return tokenFactory.getSecurityTokenInstanceFromAddress(address);

            case 15:
              securityToken = _context8.sent;
              _context8.next = 18;
              return securityToken.symbol();

            case 18:
              _symbol = _context8.sent;
              uid = entities_1.SecurityToken.generateId({
                symbol: _symbol
              });
              _context8.next = 25;
              break;

            case 22:
              _context8.prev = 22;
              _context8.t0 = _context8["catch"](12);
              throw new PolymathError_1.PolymathError({
                code: types_1.ErrorCode.FetcherValidationError,
                message: "There is no Security Token with address ".concat(address)
              });

            case 25:
              _context8.next = 31;
              break;

            case 27:
              _context8.next = 29;
              return tokenFactory.getSecurityTokenInstanceFromTicker(args.symbol);

            case 29:
              securityToken = _context8.sent;
              uid = entities_1.SecurityToken.generateId(args);

            case 31:
              _context8.next = 33;
              return securityToken.getVersion();

            case 33:
              versionArray = _context8.sent;
              versionError = new PolymathError_1.PolymathError({
                code: types_1.ErrorCode.IncorrectVersion,
                message: 'Security Token v2.0 not supported'
              });
              _context8.prev = 35;
              version = utils_1.convertVersionToEnum(versionArray);

              if ([types_1.Version.V3_0_0, types_1.Version.V3_1_0].includes(version)) {
                _context8.next = 39;
                break;
              }

              throw versionError;

            case 39:
              _context8.next = 44;
              break;

            case 41:
              _context8.prev = 41;
              _context8.t1 = _context8["catch"](35);
              throw versionError;

            case 44:
              return _context8.abrupt("return", factories.securityTokenFactory.fetch(uid));

            case 45:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[12, 22], [35, 41]]);
    }));
  };
  /**
   * Check if a token symbol (ticker) is available for reservation
   *
   * @param symbol - Security Token symbol for which to check availability
   */


  this.isSymbolAvailable = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee9() {
      var symbol;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              symbol = args.symbol;
              return _context9.abrupt("return", this.context.contractWrappers.securityTokenRegistry.tickerAvailable({
                ticker: symbol
              }));

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));
  };
  /**
   * Check if a token follows the ERC20 standard
   *
   * @param address - address of the token contract
   */


  this.isValidErc20 = function (args) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10() {
      var address, context, erc20Token;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              address = args.address;
              context = this.context;
              _context10.next = 4;
              return context.contractWrappers.tokenFactory.getERC20TokenInstanceFromAddress(address);

            case 4:
              erc20Token = _context10.sent;
              _context10.next = 7;
              return erc20Token.isValidContract();

            case 7:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));
  };
  /**
   * Retrieve a Wallet by address
   *
   * @param address - wallet address
   */


  this.getWallet = function (args) {
    var address = args.address;
    return new entities_1.Wallet({
      address: address
    }, _this.context);
  };
  /**
   * Get the current version of the Polymath Protocol
   *
   * @returns version string (i.e. 3.0.0)
   */


  this.getLatestProtocolVersion = function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11() {
      var contractWrappers, version;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              contractWrappers = this.context.contractWrappers;
              _context11.next = 3;
              return contractWrappers.securityTokenRegistry.getLatestProtocolVersion();

            case 3:
              version = _context11.sent;
              return _context11.abrupt("return", version.map(function (vNum) {
                return vNum.toNumber();
              }).join('.'));

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));
  };
  /**
   * Get the address of the POLY token
   */


  this.getPolyTokenAddress = function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee12() {
      var contractWrappers;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              contractWrappers = this.context.contractWrappers;
              return _context12.abrupt("return", contractWrappers.polyToken.address());

            case 2:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));
  };
  /**
   * Returns the wallet address of the current user
   */


  this.getCurrentAddress = function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee13() {
      var currentWallet;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              currentWallet = this.context.currentWallet;
              return _context13.abrupt("return", currentWallet.address());

            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));
  };
  /**
   * @hidden
   * Obtains a recommended default gas price based on the desired transaction speed
   *
   * On mainnet, the gas price is fetched from ethgasstation.info (most reliable)
   *
   * On testnets (or if ethgasstation is unavailable), the gas price is fetched from the network itself via eth_gasPrice
   * If everything else fails, we use a base default of 1 GWEI
   *
   * On the last two cases, the obtained price is multiplied by a factor depending on the speed:
   *
   * - Slow = x1
   * - Medium = x2
   * - Fast = x3
   * - Fastest = x5
   */


  this.getGasPrice = function (_ref6) {
    var provider = _ref6.provider,
        isTestnet = _ref6.isTestnet,
        defaultPrice = _ref6.defaultPrice,
        speed = _ref6.speed;
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee14() {
      var gasResponse, body, gasPrice, networkGasPrice;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (isTestnet) {
                _context14.next = 23;
                break;
              }

              _context14.prev = 1;
              _context14.next = 4;
              return phin_1.default({
                url: 'https://ethgasstation.info/json/ethgasAPI.json',
                parse: 'json'
              });

            case 4:
              gasResponse = _context14.sent;
              body = gasResponse.body;
              gasPrice = body.fast;
              _context14.t0 = speed;
              _context14.next = _context14.t0 === types_1.TransactionSpeed.Slow ? 10 : _context14.t0 === types_1.TransactionSpeed.Medium ? 12 : _context14.t0 === types_1.TransactionSpeed.Fast ? 14 : _context14.t0 === types_1.TransactionSpeed.Fastest ? 15 : 17;
              break;

            case 10:
              gasPrice = body.safeLow;
              return _context14.abrupt("break", 18);

            case 12:
              gasPrice = body.average;
              return _context14.abrupt("break", 18);

            case 14:
              return _context14.abrupt("break", 18);

            case 15:
              gasPrice = body.fastest;
              return _context14.abrupt("break", 18);

            case 17:
              throw new PolymathError_1.PolymathError({
                code: types_1.ErrorCode.FatalError,
                message: 'Invalid transaction speed parameter'
              });

            case 18:
              return _context14.abrupt("return", new contract_wrappers_1.BigNumber(gasPrice).multipliedBy(new contract_wrappers_1.BigNumber(10).exponentiatedBy(8)));

            case 21:
              _context14.prev = 21;
              _context14.t1 = _context14["catch"](1);

            case 23:
              _context14.next = 25;
              return new Promise(function (resolve, reject) {
                try {
                  provider.sendAsync({
                    jsonrpc: '2.0',
                    id: new Date().getTime(),
                    params: [],
                    method: 'eth_gasPrice'
                  }, function (err, resp) {
                    if (err) {
                      reject(err);
                    } else if (!resp) {
                      resolve(defaultPrice);
                    } else {
                      var price = parseInt(resp.result, 16);
                      resolve(new contract_wrappers_1.BigNumber(price));
                    }
                  });
                } catch (err) {
                  resolve(defaultPrice);
                }
              });

            case 25:
              networkGasPrice = _context14.sent;
              return _context14.abrupt("return", calculateGasPrice(speed, networkGasPrice));

            case 27:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[1, 21]]);
    }));
  };
};

exports.Polymath = Polymath;